import { Component, OnInit } from '@angular/core';
import { setTheme } from 'ngx-bootstrap/utils';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor() {
    setTheme('bs4');
  }
  title = 'app';
  ngOnInit() {
    const $ = window["$"];
    $('.menu-btn').on('click', function () {
      var elem = $(this),
        item = $('.menu__item'),
        active = 'is-active',
        play = 'menu__item--play';

      if (elem.hasClass(active)) {
        elem.removeClass(active);
        $(item.get().reverse()).each(function (i) {
          var row = $(this);
          setTimeout(function () {
            row.removeClass(play);
          }, 50 * i);
        });
      }

      else {
        elem.addClass(active);
        item.each(function (i) {
          var row = $(this);
          setTimeout(function () {
            row.addClass(play);
          }, 50 * i);
        });
      }

    });


    $("#testimonial-slider").owlCarousel({
      items: 2,
      itemsDesktop: [1000, 2],
      itemsDesktopSmall: [979, 2],
      itemsTablet: [768, 1],
      pagination: false,
      navigation: true,
      navigationText: ["", ""],
      autoPlay: true
    });

    $(".wish-icon i").click(function () {
      $(this).toggleClass("fa-heart fa-heart-o");
    });

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 50) {
        $(".clearHeader").addClass("darkHeader");
      } else {
        $(".clearHeader").removeClass("darkHeader");
      }
    });

  }
  onActivate(event) {
    window.scroll(0, 0);

  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts